import React from 'react';

import { InvalidIcon } from './invalid-icon';
import { RuleIcon, RuleWrapper } from './styles';
import { RuleProps } from './types';
import { ValidIcon } from './valid-icon';

const Rule = ({ isTouched, isValid, children }: RuleProps) => (
  <RuleWrapper>
    <RuleIcon isValid={isValid} isTouched={isTouched}>
      {isTouched && (isValid ? <ValidIcon /> : <InvalidIcon />)}
    </RuleIcon>
    {children}
  </RuleWrapper>
);
export default Rule;
